export default {
  items: {
    prices: 'תעריפון',
    disclosure: 'גילוי נאות',
    agreement: 'אמנת שירות',
    privacy: 'מדיניות פרטיות',
  },
};
